import React from 'react'

function PrivacyPolicy() {
  return (
    <div>PrivacyPolicy Coming Soon</div>
  )
}

export default PrivacyPolicy